import { FAILURE_MODES_LIST } from '../../../../constants/budget';

interface IDetailServiceHeaderProps {
  serviceDisplayName?: string;
  failureModeId?: string;
  serviceIndex: number;
}

const DetailServiceHeader = (props: IDetailServiceHeaderProps) => {
  const serviceName = (props.serviceDisplayName || '').trim();
  const failureMode = props.failureModeId
    ? FAILURE_MODES_LIST.find((m) => m.id === props.failureModeId)
    : undefined;
  const failureModeName = failureMode?.label || '';

  const getHeaderColor = (index: number): string => {
    return index % 2 === 0 ? 'bg-blue-50' : 'bg-gray-50';
  };

  if (!serviceName && !failureModeName) return null;
  return (
    <div
      className={`${getHeaderColor(
        props.serviceIndex,
      )} p-3 rounded-md mb-4 flex flex-row justify-between items-center`}
    >
      {serviceName && (
        <div className="font-bold text-size-16">{serviceName || 'Serviço'}</div>
      )}
      {failureModeName && (
        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded text-size-12 font-bold">
          {failureModeName}
        </span>
      )}
    </div>
  );
};

export default DetailServiceHeader;
